import {
  IFaqSectionFields,
  IMediaGalleryFields,
  IMediaGalleryItemFields,
  ISectionCastAndCrewFields,
  ISectionOverviewFields,
} from '@/types/generated-contentful'
import { MappedContent, mapContent } from '@/utils/TorchGuildUtil'
import CastAndCrew from './CastAndCrew'
import FAQ from './FAQ'
import MediaGallery from './MediaGallery'
import { Overview } from './Overview'

interface Props {
  content: MappedContent
}

export const Dynamic = ({ content }: Props) => {
  switch (content.contentType) {
    case 'faqSection':
      return <FAQ {...(content as unknown as IFaqSectionFields)} />
    case 'mediaGallery': {
      const mediaGalleryContent = content as unknown as IMediaGalleryFields
      return (
        <MediaGallery
          {...mediaGalleryContent}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          items={content.items.map(mapContent) as unknown as (IMediaGalleryItemFields & { id: string })[]}
          title="" // leave it blank since the ComponentWrap includes the title
        />
      )
    }
    case 'sectionCastAndCrew':
      return <CastAndCrew {...(content as unknown as ISectionCastAndCrewFields)} />
    case 'sectionOverview':
      return <Overview section={content as unknown as ISectionOverviewFields} />
    default:
      break
  }
  return null
}
